import { useEffect, useState } from 'react';
import { getApiSubRegionRegionName } from '../../../api';
import type { CountryBriefViewModelCollectionResult } from '../../../api/models';

export const useGetCountries = () => {
	const [data, setData] = useState<CountryBriefViewModelCollectionResult | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState<Error | null>(null);

	useEffect(() => {
		const fetchCountries = async () => {
			try {
				setLoading(true);
				setError(null);
				const result = await getApiSubRegionRegionName('Europa');

				setData({ ...result });

				setData(result);
			} catch (err) {
				setError(err instanceof Error ? err : new Error('Unknown error'));
			} finally {
				setLoading(false);
			}
		};

		fetchCountries();
	}, []);

	return { data, loading, error };
};
